import { Button, Modal, Popconfirm, Upload, message } from 'antd';
import { useState } from 'react';

const getImageSize = (file) => {
  return new Promise((resolve) => {
    const image = new Image();
    const url = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: image.width, height: image.height });
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    image.src = url;
  });
};

const UploadPhoto = ({ onClose, onSave, asyncSave = false, recommendedSize = null }) => {
  const [file, setFile] = useState(null);
  const [sizeMismatch, setSizeMismatch] = useState(false);
  const [checkingSize, setCheckingSize] = useState(false);

  const beforeUpload = async (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('Можно загружать только изображения');
      return Upload.LIST_IGNORE;
    }

    setFile(file);
    setSizeMismatch(false);

    if (recommendedSize) {
      setCheckingSize(true);
      const size = await getImageSize(file);
      setSizeMismatch(Boolean(size) && (size.width !== recommendedSize.width || size.height !== recommendedSize.height));
      setCheckingSize(false);
    }

    return false;
  };

  const saveFile = async () => {
    if (asyncSave) {
      const shouldClose = await onSave(file);
      if (shouldClose === false) {
        return;
      }
      onClose(true);
      return;
    }

    onSave(file);
    onClose(true);
  };

  const onSaveBtn = async (event) => {
    event?.preventDefault?.();
    if (!file) {
      message.warning('Выберите изображение перед сохранением');
      return;
    }
    await saveFile();
  };

  const formStyles = {
    content: { padding: 8 },
    footer: { marginTop: 0 },
  };

  const okButton = (<Button key="ok" type="primary" disabled={!file || checkingSize} onClick={onSaveBtn}>OK</Button>);
  const confirmOkButton = (<Button key="ok" type="primary" disabled={!file || checkingSize}>OK</Button>);

  return (
    <Modal width={400} open closeIcon={null} onCancel={() => onClose()} styles={formStyles}
      footer={[<Button key="cancel" onClick={() => onClose()}> Отмена </Button>,
        sizeMismatch ? (
          <Popconfirm key="ok" title={`Размер изображения отличается от рекомендуемого ${recommendedSize.width}x${recommendedSize.height}. Продолжить?`} okText="OK" cancelText="Отмена" onConfirm={onSaveBtn}>
            {confirmOkButton}
          </Popconfirm>
        ) : okButton,
      ]}
    >
      <Upload.Dragger name="file" beforeUpload={beforeUpload} accept="image/*" multiple={false} showUploadList={false} style={{ padding: 20, marginBottom: 8 }}>
        <p style={{ margin: 0 }}>Кликните или перетащите изображение для загрузки</p>
        <p style={{ margin: 0 }}>Макс размер файла не более 2 Мб</p>
      </Upload.Dragger>

      {file && (
        <div style={{ marginTop: 8, marginBottom: 8, textAlign: 'center' }}>
          <img
            src={URL.createObjectURL(file)}
            alt="preview"
            style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain' }}
          />
        </div>
      )}
    </Modal>
  );
};

export default UploadPhoto;
